import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Route guard for feature-flagged pages (Backtests, Data).
 *
 * Redirects rather than rendering a page whose every action would 403 — a
 * bookmarked /data for a user without backfill access should land somewhere
 * useful. As with RequireAdmin this is presentation only; the enforcement is
 * `policy.assert_feature` in the service layer.
 *
 * Admins bypass their own flags server-side, and `/users/me` reports the
 * EFFECTIVE value, so this reads the same booleans the API enforces.
 */
export default function RequireFeature({
  feature,
  children,
}: {
  feature: "backtest" | "backfill";
  children: React.ReactElement;
}) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  const allowed =
    user.is_admin ||
    (feature === "backtest" ? user.can_backtest : user.can_backfill);
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return children;
}
